module.exports = __webpack_public_path__ + "img/Technische fiches.8a878f21.svg";